// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import cartLineSharedStyles from "@turnerBlueprint/App/SharedStyles/CartLineSharedStyles";
import { quickOrderProductListStyles } from "@turnerBlueprint/Overrides/Widgets/QuickOrder/QuickOrderProductList";
import { mergeWithCss } from "@turnerBlueprint/XDL/Utilities";
import { css } from "styled-components";

quickOrderProductListStyles.wrapper = {
    css: css`
        padding-bottom: 0;
    `,
};

quickOrderProductListStyles.productImage = {
    ...cartLineSharedStyles.productImage,
};

quickOrderProductListStyles.productDescription = {
    ...cartLineSharedStyles.productDescription,
};

quickOrderProductListStyles.productNumber = {
    ...cartLineSharedStyles.productPartNumbers,
};

quickOrderProductListStyles.availability = {
    ...cartLineSharedStyles.productAvailability,
};

quickOrderProductListStyles.price = {
    ...cartLineSharedStyles.productPrice,
};

quickOrderProductListStyles.priceTotal = {
    ...cartLineSharedStyles.extendedUnitNetPriceText,
};

quickOrderProductListStyles.removeProductIcon = {
    ...cartLineSharedStyles.removeCartLineIcon,
};

quickOrderProductListStyles.addToListLink = {
    link: {
        ...cartLineSharedStyles.addToListLink,
        ...mergeWithCss(cartLineSharedStyles.addToListLink, {
            css: css`
                margin-top: 4px;
            `,
        }),
    },
};

